export const SET_ELEMENT_PARTY_MEMBER = 'SET_ELEMENT_PARTY_MEMBER';
